module.exports = __webpack_public_path__ + "static/logo-yellow-6764432004aad0e327968977d444feea.svg";